console.log(`process.env.BASE_API_URL :- ${process.env.BASE_API_URL}`);
console.log(`process.env.BASE_API_URL :- ${process.env.BASE_APP_HEADER}`);
export const BASE_URL =
  process.env.BASE_API_URL || 'https://buddy.maxfashion.in/api';

export const DEFAULT_HEADERS = {
  'Base-App': process.env.BASE_APP_HEADER || 'bmx21',
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache ,no-store',
  Pragma: 'no-cache',
  Expires: '0',
};
//1 enable 0 disable
export const encrytionEnable = 0;
export const encryptKey = 'my-secret-key@0123';
